import { getSubscriptionApiClient } from "./../../shared/apis/sidekick/api-factories";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GET_SUBSCRIPTION_STATUS_QUERY_KEY } from "./useGetSubscription";
import { apiResponseErrorHandler } from "@shared/apis/sidekick/api-error-handler";
import { toast } from "@shared/services/toast";

type Props = {
  onSuccess?: () => void;
};

type Params = {
  paymentMethodId: string;
};

export const useUpdateSubscriptionPaymentMethod = (props?: Props) => {
  const { onSuccess } = props || {};
  const api = getSubscriptionApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const response = await api.subscriptionControllerUpdatePaymentMethod({
        updatePaymentMethodRequest: {
          paymentMethodId: params.paymentMethodId,
        },
      });
      queryClient.invalidateQueries({
        queryKey: [GET_SUBSCRIPTION_STATUS_QUERY_KEY],
      });
      toast.success("Payment method updated! You're all set.");
      onSuccess?.();
      return response;
    },
    onError: async (error) => {
      const apiError = await apiResponseErrorHandler(error);
      if (apiError.status >= 400 && apiError.status < 500) {
        toast.error(apiError.errors[0]);
        return;
      }
      toast.error(
        "Failed to update subscription payment method. If the issue persists, please contact support."
      );
      console.error(`Failed to update subscription payment method`, error);
    },
  });

  return mutation;
};
